"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BitstraysDescriptorFactory = void 0;
const contracts_1 = require("@ethersproject/contracts");
class BitstraysDescriptorFactory extends contracts_1.ContractFactory {
    constructor(linkLibraryAddresses, signer) {
        super(_abi, BitstraysDescriptorFactory.linkBytecode(linkLibraryAddresses), signer);
    }
    static linkBytecode(linkLibraryAddresses) {
        let linkedBytecode = _bytecode;
        linkedBytecode = linkedBytecode.replace(new RegExp("__\\$e1d8844a0810dc0e87a665b1f2b5fa7c69\\$__", "g"), linkLibraryAddresses["__$e1d8844a0810dc0e87a665b1f2b5fa7c69$__"]
            .replace(/^0x/, "")
            .toLowerCase());
        return linkedBytecode;
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static connect(address, signerOrProvider) {
        return new contracts_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.BitstraysDescriptorFactory = BitstraysDescriptorFactory;
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bool",
                name: "enabled",
                type: "bool",
            },
        ],
        name: "AttributesToggled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "string",
                name: "baseURI",
                type: "string",
            },
        ],
        name: "BaseURIUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bool",
                name: "enabled",
                type: "bool",
            },
        ],
        name: "DataURIToggled",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "address",
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "OwnershipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "PartsLocked",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_arms",
                type: "bytes",
            },
        ],
        name: "addArms",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "_background",
                type: "string",
            },
        ],
        name: "addBackground",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "_paletteIndex",
                type: "uint8",
            },
            {
                internalType: "string",
                name: "_color",
                type: "string",
            },
        ],
        name: "addColorToPalette",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_eyes",
                type: "bytes",
            },
        ],
        name: "addEyes",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_head",
                type: "bytes",
            },
        ],
        name: "addHead",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "_arms",
                type: "bytes[]",
            },
        ],
        name: "addManyArms",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string[]",
                name: "_backgrounds",
                type: "string[]",
            },
        ],
        name: "addManyBackgrounds",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "paletteIndex",
                type: "uint8",
            },
            {
                internalType: "string[]",
                name: "newColors",
                type: "string[]",
            },
        ],
        name: "addManyColorsToPalette",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "_eyes",
                type: "bytes[]",
            },
        ],
        name: "addManyEyes",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "_heads",
                type: "bytes[]",
            },
        ],
        name: "addManyHeads",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string[]",
                name: "_metadata",
                type: "string[]",
            },
        ],
        name: "addManyMetadata",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "_motives",
                type: "bytes[]",
            },
        ],
        name: "addManyMotives",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "_mouths",
                type: "bytes[]",
            },
        ],
        name: "addManyMouths",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes[]",
                name: "_shirts",
                type: "bytes[]",
            },
        ],
        name: "addManyShirts",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_motive",
                type: "bytes",
            },
        ],
        name: "addMotive",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_mouth",
                type: "bytes",
            },
        ],
        name: "addMouth",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "_shirt",
                type: "bytes",
            },
        ],
        name: "addShirt",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "areAttributesEnabled",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "arePartsLocked",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "arms",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "armsCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "backgroundCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "backgrounds",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "baseURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "uint48",
                        name: "background",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "arms",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "shirt",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "motive",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "head",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "eyes",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "mouth",
                        type: "uint48",
                    },
                ],
                internalType: "struct IBitstraysSeeder.Seed",
                name: "seed",
                type: "tuple",
            },
        ],
        name: "dataURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "eyes",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "eyesCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint48",
                        name: "background",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "arms",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "shirt",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "motive",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "head",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "eyes",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "mouth",
                        type: "uint48",
                    },
                ],
                internalType: "struct IBitstraysSeeder.Seed",
                name: "seed",
                type: "tuple",
            },
        ],
        name: "generateSVGImage",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "name",
                type: "string",
            },
            {
                internalType: "string",
                name: "description",
                type: "string",
            },
            {
                components: [
                    {
                        internalType: "uint48",
                        name: "background",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "arms",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "shirt",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "motive",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "head",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "eyes",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "mouth",
                        type: "uint48",
                    },
                ],
                internalType: "struct IBitstraysSeeder.Seed",
                name: "seed",
                type: "tuple",
            },
        ],
        name: "genericDataURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "headCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "heads",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "isDataURIEnabled",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "lockParts",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "metadata",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "motives",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "motivesCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "mouths",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "mouthsCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "owner",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "palettes",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "renounceOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "string",
                name: "_baseURI",
                type: "string",
            },
        ],
        name: "setBaseURI",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "shirts",
        outputs: [
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "shirtsCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "toggleAttributesEnabled",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "toggleDataURIEnabled",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
            {
                components: [
                    {
                        internalType: "uint48",
                        name: "background",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "arms",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "shirt",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "motive",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "head",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "eyes",
                        type: "uint48",
                    },
                    {
                        internalType: "uint48",
                        name: "mouth",
                        type: "uint48",
                    },
                ],
                internalType: "struct IBitstraysSeeder.Seed",
                name: "seed",
                type: "tuple",
            },
        ],
        name: "tokenURI",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "traitNames",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
];
const _bytecode = "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__$e1d8844a0810dc0e87a665b1f2b5fa7c69$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$e1d8844a0810dc0e87a665b1f2b5fa7c69$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";
